import * as storage from './storage';
import { travelTypes } from '@/_data/travelTypes';

export const isInternalIp = () => {
    if (storage.get('bookingData')) {
        return storage.get('bookingData').data?.isInternal;
    } else {
        return false;
    }
};

export const setRealBooking = (travelType, value) => {
    const travelTypeList = travelTypes;

    let retObj = {
        realbooking: {},
    };

    if (travelTypeList.indexOf(travelType)) {
        retObj.realbooking[travelType] = value;
        return retObj;
    } else {
        return {};
    }
};
